<nav class="navbar navbar-expand-lg bg-dark navbar-dark">

    <div class="container-fluid">

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>

        </button>

        <div class="collapse navbar-collapse" id="navbarNav">

            <ul class="navbar-nav mr-auto">

                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">

                    <a routerLinkActive="active" routerLink="home" class="nav-link">Home
                    </a>

                </li>

                <li class="nav-item">

                    <a routerLinkActive="active" routerLink="test-translate" [routerLinkActiveOptions]="{exact:true}"
                        class="nav-link">

                        Test translate

                    </a>

                </li>

                <li class="nav-item">

                    <a routerLinkActive="active" routerLink="test-error-handle" [routerLinkActiveOptions]="{exact:true}"
                        class="nav-link">

                        Error handle

                    </a>

                </li>

                <li class="nav-item">

                    <a routerLinkActive="active" routerLink="ngrx" [routerLinkActiveOptions]="{exact:true}"
                        class="nav-link">

                        Ngrx

                    </a>

                </li>

                <li class="nav-item">

                    <a routerLinkActive="active" routerLink="test-stuff/wrapper"
                        [routerLinkActiveOptions]="{exact:true}" class="nav-link">

                        Test stuff

                    </a>

                </li>

                <lib1-shared-comp> </lib1-shared-comp>

            </ul>

        </div>

    </div>

</nav>